import React from 'react';
import T from 'prop-types';

import { BaseCsvExportButton } from './BaseCsvExportButton';
import { AsyncCsvExportButton } from './AsyncCsvExportButton';

const CsvExportButton = ({
  id,
  url,
  size,
  variant = 'secondary',
  isSquare = true,
  showIcon = true,
  disabled,
  allowCsvExport = true,
  enableTooltip = true,
  tooltipText = 'Download data to CSV',
  buttonText,
  colorVariant,
  featureNameText = 'New Seat Request from CSV export Share',
  method, // AsyncCsvExportButton prop only
  body = {}, // AsyncCsvExportButton prop only
  defaultFilename = 'download.csv', // AsyncCsvExportButton prop only
  className,
  renderCustomTooltipContent,
  onDownloadSuccess, // AsyncCsvExportButton prop only
  onVisibleChange,
}) => {
  const disabledCsvExport = !allowCsvExport || disabled;

  if (method) {
    return (
      <AsyncCsvExportButton
        id={id}
        url={url}
        size={size}
        variant={variant}
        isSquare={isSquare}
        showIcon={showIcon}
        disabled={disabledCsvExport}
        allowCsvExport={allowCsvExport}
        enableTooltip={enableTooltip}
        tooltipText={tooltipText}
        buttonText={buttonText}
        colorVariant={colorVariant}
        featureNameText={featureNameText}
        method={method}
        body={body}
        defaultFilename={defaultFilename}
        className={className}
        renderCustomTooltipContent={renderCustomTooltipContent}
        onDownloadSuccess={onDownloadSuccess}
        onVisibleChange={onVisibleChange}
      />
    );
  }

  return (
    <BaseCsvExportButton
      id={id}
      href={url}
      size={size}
      variant={variant}
      isSquare={isSquare}
      showIcon={showIcon}
      disabled={disabledCsvExport}
      allowCsvExport={allowCsvExport}
      enableTooltip={enableTooltip}
      tooltipText={tooltipText}
      buttonText={buttonText}
      featureNameText={featureNameText}
      colorVariant={colorVariant}
      className={className}
      renderCustomTooltipContent={renderCustomTooltipContent}
      onVisibleChange={onVisibleChange}
    />
  );
};

CsvExportButton.propTypes = {
  id: T.string,
  url: T.string.isRequired,
  size: T.string,
  variant: T.string,
  isSquare: T.bool,
  showIcon: T.bool,
  disabled: T.bool,
  allowCsvExport: T.bool,
  enableTooltip: T.bool,
  tooltipText: T.string,
  buttonText: T.string,
  featureNameText: T.string,
  method: T.string, // AsyncCsvExportButton prop only
  body: T.object, // AsyncCsvExportButton prop only
  defaultFilename: T.string, // AsyncCsvExportButton prop only
  className: T.string,
  onDownloadSuccess: T.func,
  renderCustomTooltipContent: T.func, // AsyncCsvExportButton prop only
  colorVariant: T.string,
  onVisibleChange: T.func,
};

export default CsvExportButton;
